module.exports = __webpack_public_path__ + "src/assets/img/preSale.0fe1d6d5.png";